import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconChat = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.60776 11.689L4.45763 11.5H4.21623H2.23064C1.41358 11.5 0.745056 10.8318 0.745056 10V2C0.745056 1.16816 1.41358 0.5 2.23064 0.5H14.1442C14.9612 0.5 15.6297 1.16816 15.6297 2V10C15.6297 10.8318 14.9612 11.5 14.1442 11.5H8.68379H8.47563L8.32897 11.6477L6.2434 13.7484L4.60776 11.689Z" stroke={color} />
        </svg>
    </div>
);

export default IconChat;
